import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import {renderRedirect} from "../util"
import { updateSignApplication } from "../Pages/BasicProfile/api";
import { spinnerService } from "../Components/spinner.service";
import Footer from "../Components/footer";


 
class GeoLocation extends Component {
  state = { errorMessage: "", successMessage: "", latitude: "", longitude: "", isPermissionDenied: false };

  async componentDidMount() {
  }
  renderRedirect = () => {
    renderRedirect(this.props, "/review");
  }
  error = (err) => {
    spinnerService.hide("mainSpinner");
    let message = "Unable to capture location. Please try again.";
    let isPermissionDenied = false;

    if (err) {
      switch (err.code) {
        case 1: // PERMISSION_DENIED
          isPermissionDenied = true;
          message = "Location permission was blocked. Please allow location access in your browser settings (see instructions below) and click Share again.";
          break;
        case 2: // POSITION_UNAVAILABLE
          message = "Location information is unavailable. Please ensure your device GPS / location services are turned on and try again.";
          break;
        case 3: // TIMEOUT
          message = "Location request timed out. Please check your network connection and click Share again.";
          break;
        default:
          message = err.message || "An unexpected error occurred while capturing location.";
          break;
      }
      console.warn(`Geolocation ERROR(${err.code}): ${err.message}`);
    }

    this.setState({ errorMessage: message, successMessage: "", isPermissionDenied });
  }

  shareLocation = () => {
    this.setState({ errorMessage: "", successMessage: "", isPermissionDenied: false });

    if (!navigator.geolocation) {
      this.setState({
        errorMessage: "Geolocation is not supported by this browser. Please try using Chrome, Safari, or Edge."
      });
      return;
    }

    if (window.isSecureContext === false) {
      this.setState({
        errorMessage: "Location requires a secure connection (HTTPS). Please ensure you are accessing this site via HTTPS."
      });
      return;
    }

    spinnerService.show("mainSpinner", "Fetching location...");

    navigator.geolocation.getCurrentPosition(
      this.showPosition,
      this.error,
      {
        timeout: 10000,
        maximumAge: 10000,
        enableHighAccuracy: true
      }
    );
  }

  showPosition = async (position) => {
    this.setState({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      isPermissionDenied: false
    });

    let reqParam = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude
    };

    try {
      await updateSignApplication(reqParam);
      spinnerService.hide("mainSpinner");
      this.setState({
        successMessage: "Your device's location was captured successfully.",
        errorMessage: ""
      });
    } catch (e) {
      spinnerService.hide("mainSpinner");
      this.setState({
        errorMessage: "Location captured, but failed to save to profile. Please click Share to retry.",
        successMessage: ""
      });
      console.error("Failed to update location:", e);
    }
  }

  render() {
    return (
      <div className="col-md-6 col-lg-5 col-xl-4">
        <div className="container my-auto py-4 bg-white shadow-lg rounded">
          <div className="row mt-2">
            <div className="col-11 col-lg-11 mx-auto">
              <h1>Share Location</h1>

              <div className="contentArea">
                <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
                  We need to collect your location for SEBI rules.
                </p>

                {!this.state.successMessage && (
                  <div className="p-3 mb-3 bg-light rounded border text-left" style={{ fontSize: "13px" }}>
                    <div className="font-weight-bold mb-2 text-dark">Steps to share:</div>
                    <div className="d-flex align-items-start mb-2">
                      <span className="badge badge-primary mr-2" style={{ padding: "5px 8px" }}>1</span>
                      <span>Click the <strong>Share Location</strong> button below</span>
                    </div>
                    <div className="d-flex align-items-start">
                      <span className="badge badge-primary mr-2" style={{ padding: "5px 8px" }}>2</span>
                      <span>Click <strong>Allow</strong> on the popup that appears</span>
                    </div>
                  </div>
                )}
              </div>

              <form id="registerForm" className="form-border" method="post">
                {this.state.errorMessage ? (
                  <span style={{ display: "block" }} className="alert alert-warning alert-dismissible fade show text-left">
                    {this.state.errorMessage}
                  </span>
                ) : null}

                {this.state.isPermissionDenied && (
                  <div className="alert alert-info text-left text-1 mt-2" style={{ fontSize: "13px" }}>
                    <strong>How to unblock location:</strong>
                    <ul className="pl-3 mb-1 mt-1">
                      <li><strong>Chrome / Edge:</strong> Click the lock 🔒 or tune icon in the address bar &rarr; Set <em>Location</em> to <strong>Allow</strong> &rarr; Click <em>Share Location</em>.</li>
                      <li><strong>Safari (iOS / Mac):</strong> Tap <code>aA</code> or lock icon in the URL bar &rarr; <em>Website Settings</em> &rarr; Set <em>Location</em> to <strong>Allow</strong>.</li>
                      <li><strong>Android:</strong> Tap the lock 🔒 in the URL bar &rarr; <em>Permissions</em> &rarr; <strong>Allow Location</strong>.</li>
                    </ul>
                  </div>
                )}

                {this.state.successMessage ? (
                  <span style={{ display: "block" }} className="alert alert-success alert-dismissible fade show text-left">
                    {this.state.successMessage}
                  </span>
                ) : null}

                {this.state.successMessage === "" && (
                  <button className="btn btn-primary btn-block text-uppercase mt-4" type="button" onClick={this.shareLocation}>
                    Share Location
                  </button>
                )}

                {this.state.successMessage !== "" && (
                  <button className="btn btn-primary btn-block text-uppercase mt-4" type="button" onClick={this.renderRedirect}>
                    NEXT
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
export default withRouter(GeoLocation);